'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import {
  COOKIE_PREFERENCES_EVENT,
  applyAttributionConsent,
  captureAttribution,
} from '@/lib/attribution';

/**
 * Records where the visitor came from on every route change, within the cookie
 * choice (lib/attribution.ts), and applies a new choice as soon as the banner
 * saves it. Reads the query string from window.location rather than
 * useSearchParams, which would need its own Suspense boundary on every page.
 * Renders nothing.
 */
export default function AttributionCapture() {
  const pathname = usePathname();

  useEffect(() => {
    captureAttribution();
  }, [pathname]);

  useEffect(() => {
    window.addEventListener(COOKIE_PREFERENCES_EVENT, applyAttributionConsent);
    return () =>
      window.removeEventListener(
        COOKIE_PREFERENCES_EVENT,
        applyAttributionConsent
      );
  }, []);

  return null;
}
